const Images = {
    product: require('../assets/images/Xpanse.png'),
    xpanse: require('../assets/images/brand-logo.png'),
    xpanse2: require('../assets/images/upcoming-cafe.png'),
    xpanse3: require('../assets/images/upcomingOutlet.png'),
    xpanse4: require('../assets/images/xpanse4.png'),
    scanBird: require('../assets/images/emptyCartBird.png'),
    subBird: require('../assets/images/subSearchBird.png'),
    orderBird: require('../assets/images/subBird.png'),

    // Banner Images
    banner1: require('../assets/images/banner-1.png'),
    banner2: require('../assets/images/banner-2.png'),
    banner3: require('../assets/images/banner-3.jpeg'),
};

export default Images;
